import { useTheme } from '@mui/material';
import { useCurrentBreakpoint } from 'shared/hooks/useCurrentBreakpoint';

export const useBooleanScreens = () => {
  const theme = useTheme();
  const cb = useCurrentBreakpoint();

  return {
    cb,
    isLessTablet:
      theme.breakpoints.values[cb] < theme.breakpoints.values['tablet'],
    isLessLaptop:
      theme.breakpoints.values[cb] < theme.breakpoints.values['laptop'],
    isLessDesktopSmall:
      theme.breakpoints.values[cb] < theme.breakpoints.values['desktop_small'],
  };
};
